import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Enum-like fields (client_side, status, etc.) are stored lowercase in the
// database — this is the one place that turns them into display text, so
// every place that shows one to a user renders the same casing instead of
// each page picking its own (raw, CSS `capitalize`, manual .replace()).
export function titleCase(value?: string | null): string {
  if (!value) return '';
  return value
    .replace(/_/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(' ');
}
